export default "__VITE_ASSET__BrvhgdLk__"